import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const mainCategories = categories.filter((c) => ['taibei-nana', 'molixiu', 'wandou-jiejie', 'renwu-zhuanji', 'xilie-zhuanti', 'wanghong-dongtai', 'remen-bagua'].includes(c.slug));

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-emotion-happy-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold font-heading text-background-50">
                  51吃瓜网
                </span>
              </div>
              <p className="text-sm leading-relaxed text-background-400">
                国内领先的网红资讯与娱乐内容平台，为千万粉丝提供最新、最全、最有趣的网红动态。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-categories" className="hover:text-background-200 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2">
                {mainCategories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-links" className="hover:text-background-200 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/renwu-zhuanji" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                    人物合集
                  </Link>
                </li>
                <li>
                  <Link to="/category/xilie-zhuanti" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                    系列专题
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-contact" className="hover:text-background-200 transition-colors">联系我们</a>
              </h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line"></i>
                  <span>contact@51chigua.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-wechat-line"></i>
                  <span>chigua51_official</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line"></i>
                  <span>北京市朝阳区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 51吃瓜网 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}